// Handle normalisation — used at signup + every read.
// All seller doc IDs are lowercased ASCII alphanumerics.

const RE = /^[a-z0-9][a-z0-9_-]{2,23}$/;

export function normalizeHandle(input) {
  return String(input || "")
      .toLowerCase()
      .replace(/[^a-z0-9_-]/g, "")
      .slice(0, 24);
}

export function isValidHandle(h) {
  return RE.test(h);
}

export function handleValidationError(h) {
  if (!h) return "Handle is required";
  if (h.length < 3) return "Handle must be at least 3 characters";
  if (h.length > 24) return "Handle must be 24 characters or fewer";
  if (!RE.test(h)) return "Use letters, numbers, _ or - only (start with letter or number)";
  return null;
}
